import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initKeycloak } from './app/auth/keycloak.service';
import {
  PENDING_WORKFLOW_LINK_KEY,
  stripAuthResponseParams,
  WORKFLOW_DEEP_LINK_PATH,
} from './app/workflow-deep-link';
import { restoreNavigationStateBeforeBootstrap } from './app/services/refresh-state/refresh-state.service';

function renderBootstrapError(): void {
  const container = document.createElement('div');
  container.style.fontFamily = 'Arial, sans-serif';
  container.style.padding = '2rem';
  container.style.color = '#1f2937';

  const heading = document.createElement('h1');
  heading.style.marginBottom = '0.5rem';
  heading.textContent = 'Startup failed';

  const message = document.createElement('p');
  message.style.margin = '0';
  message.textContent = 'The application could not initialize. If the issue persists, please contact support.';

  container.append(heading, message);
  document.body.replaceChildren(container);
}

/**
 * D3: emailed workflow links are path-style (`/workflow/link/<token>`) so the same URL can be
 * claimed by the mobile app, but this app uses hash routing — so the path is rewritten into
 * the hash before Angular boots.
 *
 * The destination is also stashed, because Keycloak returns its auth response in the URL
 * fragment and strips it afterwards, which would otherwise take the route with it. AppComponent
 * replays it once the app is up.
 */
function normalizeWorkflowDeepLink(): void {
  const { pathname, search, hash } = window.location;

  const fromHash = /^#(\/workflow\/(?:link|item)\/.+)$/.exec(hash);
  if (fromHash) {
    // Keycloak welds code/state/session_state onto the last segment; drop them.
    sessionStorage.setItem(PENDING_WORKFLOW_LINK_KEY, stripAuthResponseParams(fromHash[1]));
    return;
  }

  if (hash) return;
  if (!WORKFLOW_DEEP_LINK_PATH.test(pathname)) return;

  sessionStorage.setItem(PENDING_WORKFLOW_LINK_KEY, pathname);
  window.history.replaceState({}, '', `/#${pathname}${search}`);
}

normalizeWorkflowDeepLink();

initKeycloak()
  .then(() => {
    restoreNavigationStateBeforeBootstrap();
    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .catch((error) => {
    console.error('Keycloak initialization failed:', error);
    renderBootstrapError();
  });
